var React = require('react');

function ContactUsPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"contact-us","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M4.7046301 4.7046301s339.5 26.57578876 387 319.57578876c90 290 168 367.5 530.5 275s338 55 613 55"}));
}

ContactUsPath.defaultProps = {"viewBox":"0 0 1539.909 658.985"};

module.exports = ContactUsPath;

ContactUsPath.default = ContactUsPath;
